export default "__VITE_ASSET__BDHkrKAt__"